(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/answer/answer.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/answer/answer.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div [ngStyle]=\"{'background-color': color?.colorMain}\" class=\"btn-select\">\n    <div [ngStyle]=\"{'background-color': isSelect ? color?.colorSelect : 'white'}\" class=\"btn-select-center\">\n    </div>\n</div>\n<div class=\"text\">\n    {{ answer?.text }}\n</div>\n<div [ngStyle]=\"{'border-color': color?.colorMain}\" class=\"frame\"></div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/bar-info-detail/bar-info-detail.component.html":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/bar-info-detail/bar-info-detail.component.html ***!
  \****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"text\">\n   {{ text }}\n</div>\n<div  class=\"frame\"></div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/bar-info/bar-info.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/bar-info/bar-info.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\n    <div class=\"bar-top\">\n        <span class=\"text-bar-top\">\n            {{title}}\n        </span>\n    </div>\n    <div [ngStyle]=\"{'background-color': color}\" class=\"bar-bottom\">\n        <bar-info-detail [text]=\"content\" class=\"frame\"></bar-info-detail>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/btnfinish/btnfinish.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/btnfinish/btnfinish.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/chart-data/chart-data.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/chart-data/chart-data.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<canvas width=\"500\" height=\"500\" #canvas></canvas>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/chart-info/chart-info.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/chart-info/chart-info.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<img  [@fadeBasic]=\"open ? 'show' : 'hide'\"  (@fadeBasic.done)=\"endFade()\" [src]=\"srcImg\" (load)=\"loadImg()\">");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/img-base/img-base.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/img-base/img-base.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<img  [@fadeBasic]=\"open ? 'show' : 'hide'\"  (@fadeBasic.done)=\"endFade()\" [src]=\"srcImg\" (load)=\"loadImg()\">\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/label-next/label-next.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/label-next/label-next.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div [ngStyle]=\"{'background-color': color}\" class=\"container\">\n    <span>\n        Elige la respuesta con la que más te sientes identificado (a).\n    </span>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/line-question/line-question.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/line-question/line-question.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\n    <div *ngFor=\"let color of listColors; let i = index\" [ngStyle]=\"{'background-color': color, 'visibility': i > postLine - 1 ? 'hidden' : 'unset' }\" class=\"circle-max\" >\n        <div class=\"circle-min\">\n        </div>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/loader-msg/loader-msg.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/loader-msg/loader-msg.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div  class=\"modal\">\n    <div class=\"logo\">\n    </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/msg-box/msg-box.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/msg-box/msg-box.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal\">\n    <div class=\"modal-content\">\n        <div class=\"text\">\n            Se debe seleccionar al menos una de las opciones.\n        </div>\n        <div>\n            <div  (click)=\"click()\" [ngStyle]=\"{'background-color': color}\" class=\"btn\">\n                Cerrar\n            </div>\n        </div>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/question-form/question-form.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/question-form/question-form.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\n    <question  [question]=\"question\" [color]=\"listColorMain[indexColor].colorMain\"></question>\n    <answer [ngStyle]=\"{'border-color': listColorMain[indexColor].colorMain}\"  *ngFor=\"let answer of question?.answer; let i = index\" [answer]=\"answer\"  (click)=\"clickAnswer(i)\" [isSelect]=\"selectAnswer[i]\" [color]=\"listColorMain[indexColor]\"></answer>\n    <label-next [color]=\"listColorMain[indexColor].colorMain\"></label-next>\n    <btnfinish [ngClass]=\"classAnimation\" (click)=\"clickNext()\" ></btnfinish>\n    <line-question [listColors]= \"listColorLine\" [postLine]=\"indexQuestion + 1\" ></line-question>\n</div>\n<msg-box *ngIf=\"openMsgBox\"  [color]=\"listColorMain[indexColor].colorMain\" (clickClose)=\"clickMsgBox()\"  ></msg-box>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/question/question.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/question/question.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\n    <div class=\"bar-top\">\n        <span class=\"text-bar-top\">\n            Test\n        </span>\n    </div>\n    <div [ngStyle]=\"{'background-color': color}\" class=\"bar-bottom\">\n        <span class=\"text-bar-bottom\">\n            {{question?.text}}\n        </span>\n    </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/result/result.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/component/result/result.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div>\n    <div class=\"img-main\">\n        <img-base [src]=\"dataPoints[index].img\" ></img-base>\n    </div>\n    \n    <div class=\"content-chart\">\n        <chart-info [src]=\"dataPoints[index].imgData\"></chart-info>\n    </div>\n\n    <div class=\"chart-point\">\n            <chart-data (clickChartNext)=\"nextItem($event)\" [dataPoint]=\"dataPointResult\"></chart-data>\n        </div>\n\n    <div class=\"bar-desc\">\n        <bar-info [title]=\"dataPoints[index].title\" [content]=\"dataPoints[index].text\" [color]=\"dataPoints[index].color.colorMain\" ></bar-info>\n    </div>\n</div>\n<div (click)=\"toHome()\" class=\"btn-home\">\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/page/home-page/home-page.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/page/home-page/home-page.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\" (mouseover)=\"playAudio()\">\n    <div class=\"content\">\n        <div class=\"logo\"></div>\n        <div (click)=\"clickPlay()\" class=\"btn\">\n            <span>\n                Iniciar\n            </span>\n        </div>\n    </div>\n</div>\n<!-- <div (click)=\"clickInfo()\" class=\"info\"> -->\n<!-- </div> -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/page/play-page/play-page.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/page/play-page/play-page.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<loader-msg *ngIf=\"!isLoader\"></loader-msg>\n<question-form *ngIf=\"!isFinishQuestion\" [indexQuestion]=\"indexQuestion\" [indexColor]=\"indexColor\" [question]=\"questionMain\" (clickNextQuestion)=\"nextQuestion($event)\" ></question-form>\n<result *ngIf=\"isFinishQuestion\" [dataPoint]=\"resultQuestion\" ></result>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/animation.ts":
/*!******************************!*\
  !*** ./src/app/animation.ts ***!
  \******************************/
/*! exports provided: widthMinToMax, fadeBasic, slideDown, slideRight, scaleRadius */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "widthMinToMax", function() { return widthMinToMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fadeBasic", function() { return fadeBasic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slideDown", function() { return slideDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slideRight", function() { return slideRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scaleRadius", function() { return scaleRadius; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");


function widthMinToMax(min, max, timeMin = '1s ease-in', timeMax = '1s ease-in') {
    return Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('widthMinToMax', [
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('min', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            width: min
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('max', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            width: max
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('min => max', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeMin)
        ]),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('max => min', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeMax)
        ])
    ]);
}
function fadeBasic(max = '1', min = '0', timeHide = '1s ease-in', timeShow = '1s ease-in') {
    return Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('fadeBasic', [
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('show', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            opacity: max
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('hide', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            opacity: min
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('show => hide', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeHide)
        ]),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('hide => show', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeShow)
        ])
    ]);
}
function slideDown(timeOpen = '1s ease-in', timeClose = '1s ease-in') {
    return Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('slideDown', [
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('open', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            transform: 'translate(0, 0%)'
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('closed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            transform: 'translate(0, -100%)'
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('open => closed', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeClose)
        ]),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('closed => open', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeOpen)
        ]),
    ]);
}
function slideRight(timeOpen = '1s ease-in', timeClose = '1s ease-in') {
    return Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('slideRight', [
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('open', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            transform: 'translate(0%, 0)'
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('closed', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            transform: 'translate(100%, 0)'
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('open => closed', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeClose)
        ]),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('closed => open', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeOpen)
        ]),
    ]);
}
function scaleRadius(timeShow = '1s', timeHide = '1s', minScaleX = '0', minScaleY = '0', maxScaleX = '1', maxScaleY = '1', MinBorderRadius = '50%', MaxBorderRadius = '0%') {
    return Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["trigger"])('scaleRadius', [
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('hide', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            transform: `scale(${minScaleX}, ${minScaleY})`,
            borderRadius: MinBorderRadius
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["state"])('show', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["style"])({
            transform: `scale(${maxScaleX}, ${maxScaleY})`,
            borderRadius: MaxBorderRadius
        })),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('hide => show', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeShow)
        ]),
        Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["transition"])('show => hide', [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_1__["animate"])(timeHide)
        ]),
    ]);
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _page_play_page_play_page_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./page/play-page/play-page.component */ "./src/app/page/play-page/play-page.component.ts");
/* harmony import */ var _page_home_page_home_page_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./page/home-page/home-page.component */ "./src/app/page/home-page/home-page.component.ts");





const routes = [
    { path: 'play', component: _page_play_page_play_page_component__WEBPACK_IMPORTED_MODULE_3__["PlayPageComponent"] },
    { path: 'home', component: _page_home_page_home_page_component__WEBPACK_IMPORTED_MODULE_4__["HomePageComponent"] },
    { path: '', redirectTo: 'home', pathMatch: 'full' }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { useHash: true })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host{\n    --primary-color: #2b4d8b;\n    --text-light: white;\n    --text-dark: #434040;\n}\n\n@-webkit-keyframes pulse-scale {\n    0% { transform: scale(1); }\n    50% {  transform: scale(0.9);}\n    100% { transform: scale(1); }\n}\n\n@keyframes pulse-scale {\n    0% { transform: scale(1); }\n    50% {  transform: scale(0.9);}\n    100% { transform: scale(1); }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSx3QkFBd0I7SUFDeEIsbUJBQW1CO0lBQ25CLG9CQUFvQjtBQUN4Qjs7QUFFQTtJQUNJLEtBQUssbUJBQW1CLEVBQUU7SUFDMUIsT0FBTyxxQkFBcUIsQ0FBQztJQUM3QixPQUFPLG1CQUFtQixFQUFFO0FBQ2hDOztBQUpBO0lBQ0ksS0FBSyxtQkFBbUIsRUFBRTtJQUMxQixPQUFPLHFCQUFxQixDQUFDO0lBQzdCLE9BQU8sbUJBQW1CLEVBQUU7QUFDaEMiLCJmaWxlIjoic3JjL2FwcC9hcHAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0e1xuICAgIC0tcHJpbWFyeS1jb2xvcjogIzJiNGQ4YjtcbiAgICAtLXRleHQtbGlnaHQ6IHdoaXRlO1xuICAgIC0tdGV4dC1kYXJrOiAjNDM0MDQwO1xufVxuXG5Aa2V5ZnJhbWVzIHB1bHNlLXNjYWxlIHtcbiAgICAwJSB7IHRyYW5zZm9ybTogc2NhbGUoMSk7IH1cbiAgICA1MCUgeyAgdHJhbnNmb3JtOiBzY2FsZSgwLjkpO31cbiAgICAxMDAlIHsgdHJhbnNmb3JtOiBzY2FsZSgxKTsgfVxufSJdfQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'Comtic';
    }
};
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _component_question_question_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./component/question/question.component */ "./src/app/component/question/question.component.ts");
/* harmony import */ var _component_answer_answer_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./component/answer/answer.component */ "./src/app/component/answer/answer.component.ts");
/* harmony import */ var _component_question_form_question_form_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./component/question-form/question-form.component */ "./src/app/component/question-form/question-form.component.ts");
/* harmony import */ var _component_line_question_line_question_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./component/line-question/line-question.component */ "./src/app/component/line-question/line-question.component.ts");
/* harmony import */ var _component_btnfinish_btnfinish_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./component/btnfinish/btnfinish.component */ "./src/app/component/btnfinish/btnfinish.component.ts");
/* harmony import */ var _component_label_next_label_next_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./component/label-next/label-next.component */ "./src/app/component/label-next/label-next.component.ts");
/* harmony import */ var _page_play_page_play_page_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./page/play-page/play-page.component */ "./src/app/page/play-page/play-page.component.ts");
/* harmony import */ var _component_result_result_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./component/result/result.component */ "./src/app/component/result/result.component.ts");
/* harmony import */ var _component_bar_info_bar_info_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./component/bar-info/bar-info.component */ "./src/app/component/bar-info/bar-info.component.ts");
/* harmony import */ var _component_img_base_img_base_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./component/img-base/img-base.component */ "./src/app/component/img-base/img-base.component.ts");
/* harmony import */ var _component_chart_info_chart_info_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./component/chart-info/chart-info.component */ "./src/app/component/chart-info/chart-info.component.ts");
/* harmony import */ var _component_chart_data_chart_data_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./component/chart-data/chart-data.component */ "./src/app/component/chart-data/chart-data.component.ts");
/* harmony import */ var _page_home_page_home_page_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./page/home-page/home-page.component */ "./src/app/page/home-page/home-page.component.ts");
/* harmony import */ var _component_loader_msg_loader_msg_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./component/loader-msg/loader-msg.component */ "./src/app/component/loader-msg/loader-msg.component.ts");
/* harmony import */ var _component_bar_info_detail_bar_info_detail_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./component/bar-info-detail/bar-info-detail.component */ "./src/app/component/bar-info-detail/bar-info-detail.component.ts");
/* harmony import */ var _component_msg_box_msg_box_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./component/msg-box/msg-box.component */ "./src/app/component/msg-box/msg-box.component.ts");























let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"],
            _component_question_question_component__WEBPACK_IMPORTED_MODULE_7__["QuestionComponent"],
            _component_answer_answer_component__WEBPACK_IMPORTED_MODULE_8__["AnswerComponent"],
            _component_question_form_question_form_component__WEBPACK_IMPORTED_MODULE_9__["QuestionFormComponent"],
            _component_line_question_line_question_component__WEBPACK_IMPORTED_MODULE_10__["LineQuestionComponent"],
            _component_btnfinish_btnfinish_component__WEBPACK_IMPORTED_MODULE_11__["BtnfinishComponent"],
            _component_label_next_label_next_component__WEBPACK_IMPORTED_MODULE_12__["LabelNextComponent"],
            _page_play_page_play_page_component__WEBPACK_IMPORTED_MODULE_13__["PlayPageComponent"],
            _component_result_result_component__WEBPACK_IMPORTED_MODULE_14__["ResultComponent"],
            _component_bar_info_bar_info_component__WEBPACK_IMPORTED_MODULE_15__["BarInfoComponent"],
            _component_img_base_img_base_component__WEBPACK_IMPORTED_MODULE_16__["ImgBaseComponent"],
            _component_chart_info_chart_info_component__WEBPACK_IMPORTED_MODULE_17__["ChartInfoComponent"],
            _component_chart_data_chart_data_component__WEBPACK_IMPORTED_MODULE_18__["ChartDataComponent"],
            _page_home_page_home_page_component__WEBPACK_IMPORTED_MODULE_19__["HomePageComponent"],
            _component_loader_msg_loader_msg_component__WEBPACK_IMPORTED_MODULE_20__["LoaderMsgComponent"],
            _component_bar_info_detail_bar_info_detail_component__WEBPACK_IMPORTED_MODULE_21__["BarInfoDetailComponent"],
            _component_msg_box_msg_box_component__WEBPACK_IMPORTED_MODULE_22__["MsgBoxComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_5__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_2__["BrowserAnimationsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpClientModule"],
        ],
        providers: [],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/component/answer/answer.component.css":
/*!*******************************************************!*\
  !*** ./src/app/component/answer/answer.component.css ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host{\n    display: flex;\n    width: 50%;\n    min-height: 6em;\n    height: auto;\n\n    position: relative;\n    align-items: center;\n    padding: 0.5em;\n}\n\n.btn-select{\n    display: flex;\n    height: 2.5em;\n    width: 2.5em;\n    border-radius: 50%;\n    margin-left: -2em;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-select-center{\n    height: 1em;\n    width: 1em;\n    border-radius: 50%;\n    background-color: white;\n    z-index: 100;\n}\n\n.text{\n    width: 100%;\n    margin-left: 0.5em;\n    margin-right: 0.5em;\n    text-align: justify;\n    font-size: 1.5em;\n    font-weight: bold;\n    color: var(--text-dark);\n}\n\n.frame{\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    transform: rotate(-1deg);\n    border: 2px solid;\n    border-radius: 1em;\n    margin-left: -0.5em;\n}\n\n@media (max-width: 500px){\n    :host{\n        width: 90%;\n    }\n\n    .btn-select{\n        margin-left: -1.5em;\n    }\n}\n\n@media (max-width: 1023px){\n    :host{\n        width: 90%;\n    }\n}\n\n@media(min-width: 1200px) and (min-height: 1080px)  { \n    :host{\n        height: auto;\n        min-height: 15em;\n        \n    }\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/component/answer/answer.component.ts":
/*!******************************************************!*\
  !*** ./src/app/component/answer/answer.component.ts ***!
  \******************************************************/
/*! exports provided: AnswerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnswerComponent", function() { return AnswerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AnswerComponent = class AnswerComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], AnswerComponent.prototype, "color", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], AnswerComponent.prototype, "isSelect", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], AnswerComponent.prototype, "answer", void 0);
AnswerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'answer',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./answer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/answer/answer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./answer.component.css */ "./src/app/component/answer/answer.component.css")).default]
    })
], AnswerComponent);



/***/ }),

/***/ "./src/app/component/bar-info-detail/bar-info-detail.component.css":
/*!*************************************************************************!*\
  !*** ./src/app/component/bar-info-detail/bar-info-detail.component.css ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host{\n    display: flex;\n    width: 100%;\n    height: auto;\n    position: relative;\n    align-items: center;\n    padding: 0.5em;\n}\n\n.text{\n    width: 100%;\n    margin: 0.5em;\n    text-align: right;\n    font-size: 1.5em;\n    font-weight: bold;\n    color: var(--text-dark);\n}\n\n.frame{\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    transform: rotate(-1deg);\n    border: 2px solid white;\n    border-radius: 0.5em;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2Jhci1pbmZvLWRldGFpbC9iYXItaW5mby1kZXRhaWwuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7SUFDYixXQUFXO0lBQ1gsWUFBWTtJQUNaLGtCQUFrQjtJQUNsQixtQkFBbUI7SUFDbkIsY0FBYztBQUNsQjs7QUFFQTtJQUNJLFdBQVc7SUFDWCxhQUFhO0lBQ2IsaUJBQWlCO0lBQ2pCLGdCQUFnQjtJQUNoQixpQkFBaUI7SUFDakIsdUJBQXVCO0FBQzNCOztBQUVBO0lBQ0ksV0FBVztJQUNYLFlBQVk7SUFDWixrQkFBa0I7SUFDbEIsd0JBQXdCO0lBQ3hCLHVCQUF1QjtJQUN2QixvQkFBb0I7QUFDeEIiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnQvYmFyLWluZm8tZGV0YWlsL2Jhci1pbmZvLWRldGFpbC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3R7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IGF1dG87XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgcGFkZGluZzogMC41ZW07XG59XG5cbi50ZXh0e1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG1hcmdpbjogMC41ZW07XG4gICAgdGV4dC1hbGlnbjogcmlnaHQ7XG4gICAgZm9udC1zaXplOiAxLjVlbTtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICBjb2xvcjogdmFyKC0tdGV4dC1kYXJrKTtcbn1cblxuLmZyYW1le1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgdHJhbnNmb3JtOiByb3RhdGUoLTFkZWcpO1xuICAgIGJvcmRlcjogMnB4IHNvbGlkIHdoaXRlO1xuICAgIGJvcmRlci1yYWRpdXM6IDAuNWVtO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/component/bar-info-detail/bar-info-detail.component.ts":
/*!************************************************************************!*\
  !*** ./src/app/component/bar-info-detail/bar-info-detail.component.ts ***!
  \************************************************************************/
/*! exports provided: BarInfoDetailComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BarInfoDetailComponent", function() { return BarInfoDetailComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let BarInfoDetailComponent = class BarInfoDetailComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarInfoDetailComponent.prototype, "text", void 0);
BarInfoDetailComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'bar-info-detail',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./bar-info-detail.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/bar-info-detail/bar-info-detail.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./bar-info-detail.component.css */ "./src/app/component/bar-info-detail/bar-info-detail.component.css")).default]
    })
], BarInfoDetailComponent);



/***/ }),

/***/ "./src/app/component/bar-info/bar-info.component.css":
/*!***********************************************************!*\
  !*** ./src/app/component/bar-info/bar-info.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n    width: 100%;\n    height: 100%;\n}\n\n.bar-top{\n    display: flex;\n    height: 3em;\n    border-top-right-radius: 0.5em;\n    align-items: center;\n    justify-content: flex-end;\n    background-color: var(--primary-color);\n}\n\n.bar-bottom{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n\n    min-height: 10em;\n    height: auto;\n    border-bottom-right-radius: 2em;\n    padding-right: 1.5em;\n    padding-left: 5%;\n}\n\n.text-bar-top {\n    font-weight: bold;\n    color: var(--text-light);\n    font-size: 1.5em;\n    margin-right: 1em;\n}\n\n.frame{\n    border: 2px solid white;\n    border-radius: 0.5em;\n}\n\n@media (max-width: 1600px){\n    .bar-bottom{\n        height: auto;\n        padding: 1em;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2Jhci1pbmZvL2Jhci1pbmZvLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0lBQ1gsWUFBWTtBQUNoQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixXQUFXO0lBQ1gsOEJBQThCO0lBQzlCLG1CQUFtQjtJQUNuQix5QkFBeUI7SUFDekIsc0NBQXNDO0FBQzFDOztBQUVBO0lBQ0ksYUFBYTtJQUNiLG1CQUFtQjtJQUNuQix5QkFBeUI7O0lBRXpCLGdCQUFnQjtJQUNoQixZQUFZO0lBQ1osK0JBQStCO0lBQy9CLG9CQUFvQjtJQUNwQixnQkFBZ0I7QUFDcEI7O0FBRUE7SUFDSSxpQkFBaUI7SUFDakIsd0JBQXdCO0lBQ3hCLGdCQUFnQjtJQUNoQixpQkFBaUI7QUFDckI7O0FBRUE7SUFDSSx1QkFBdUI7SUFDdkIsb0JBQW9CO0FBQ3hCOztBQUVBO0lBQ0k7UUFDSSxZQUFZO1FBQ1osWUFBWTtJQUNoQjtBQUNKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L2Jhci1pbmZvL2Jhci1pbmZvLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGFpbmVye1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbn1cblxuLmJhci10b3B7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBoZWlnaHQ6IDNlbTtcbiAgICBib3JkZXItdG9wLXJpZ2h0LXJhZGl1czogMC41ZW07XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLXByaW1hcnktY29sb3IpO1xufVxuXG4uYmFyLWJvdHRvbXtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcblxuICAgIG1pbi1oZWlnaHQ6IDEwZW07XG4gICAgaGVpZ2h0OiBhdXRvO1xuICAgIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiAyZW07XG4gICAgcGFkZGluZy1yaWdodDogMS41ZW07XG4gICAgcGFkZGluZy1sZWZ0OiA1JTtcbn1cblxuLnRleHQtYmFyLXRvcCB7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgY29sb3I6IHZhcigtLXRleHQtbGlnaHQpO1xuICAgIGZvbnQtc2l6ZTogMS41ZW07XG4gICAgbWFyZ2luLXJpZ2h0OiAxZW07XG59XG5cbi5mcmFtZXtcbiAgICBib3JkZXI6IDJweCBzb2xpZCB3aGl0ZTtcbiAgICBib3JkZXItcmFkaXVzOiAwLjVlbTtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDE2MDBweCl7XG4gICAgLmJhci1ib3R0b217XG4gICAgICAgIGhlaWdodDogYXV0bztcbiAgICAgICAgcGFkZGluZzogMWVtO1xuICAgIH1cbn0iXX0= */");

/***/ }),

/***/ "./src/app/component/bar-info/bar-info.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/component/bar-info/bar-info.component.ts ***!
  \**********************************************************/
/*! exports provided: BarInfoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BarInfoComponent", function() { return BarInfoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let BarInfoComponent = class BarInfoComponent {
    constructor() {
        this.title = "Competencia pedagogica";
        this.content = "Capacidad de utilizar las tic para fortslecer los procesos de enselanza y aprendizaje reconocimiento alcances y limitaciones de las incporracion de estas tecnologiuas en la formacion imntegral de los estudiantes en su propio desarrollo personal";
        this.color = 'red';
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarInfoComponent.prototype, "title", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarInfoComponent.prototype, "content", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], BarInfoComponent.prototype, "color", void 0);
BarInfoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'bar-info',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./bar-info.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/bar-info/bar-info.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./bar-info.component.css */ "./src/app/component/bar-info/bar-info.component.css")).default]
    })
], BarInfoComponent);



/***/ }),

/***/ "./src/app/component/btnfinish/btnfinish.component.css":
/*!*************************************************************!*\
  !*** ./src/app/component/btnfinish/btnfinish.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (":host{\n    position: absolute;\n    right: 4%;\n    bottom: 7em;\n    height: 3.5em;\n    width: 12em;\n    cursor: pointer;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;  \n    background-image: url('btn-next.png');\n}\n\n@media (max-height: 767px){\n    :host{\n        display: block;\n        position: relative;\n        margin-left: auto;\n        margin-top: -4em;\n    }\n}\n\n@media (min-width: 865px) and (max-width: 1024px) and (min-height: 768px){\n    :host{\n        display: block;\n        position: relative;\n        margin-left: auto;\n        margin-top: -4em;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2J0bmZpbmlzaC9idG5maW5pc2guY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGtCQUFrQjtJQUNsQixTQUFTO0lBQ1QsV0FBVztJQUNYLGFBQWE7SUFDYixXQUFXO0lBQ1gsZUFBZTtJQUNmLDRCQUE0QjtJQUM1QiwwQkFBMEI7SUFDMUIscUNBQXFEO0FBQ3pEOztBQUVBO0lBQ0k7UUFDSSxjQUFjO1FBQ2Qsa0JBQWtCO1FBQ2xCLGlCQUFpQjtRQUNqQixnQkFBZ0I7SUFDcEI7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksY0FBYztRQUNkLGtCQUFrQjtRQUNsQixpQkFBaUI7UUFDakIsZ0JBQWdCO0lBQ3BCO0FBQ0oiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnQvYnRuZmluaXNoL2J0bmZpbmlzaC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3R7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHJpZ2h0OiA0JTtcbiAgICBib3R0b206IDdlbTtcbiAgICBoZWlnaHQ6IDMuNWVtO1xuICAgIHdpZHRoOiAxMmVtO1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICAgIGJhY2tncm91bmQtc2l6ZTogMTAwJSAxMDAlOyAgXG4gICAgYmFja2dyb3VuZC1pbWFnZTogdXJsKCdzcmMvYXNzZXRzL3BsYXkvYnRuLW5leHQucG5nJyk7XG59XG5cbkBtZWRpYSAobWF4LWhlaWdodDogNzY3cHgpe1xuICAgIDpob3N0e1xuICAgICAgICBkaXNwbGF5OiBibG9jaztcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICBtYXJnaW4tbGVmdDogYXV0bztcbiAgICAgICAgbWFyZ2luLXRvcDogLTRlbTtcbiAgICB9XG59XG5cbkBtZWRpYSAobWluLXdpZHRoOiA4NjVweCkgYW5kIChtYXgtd2lkdGg6IDEwMjRweCkgYW5kIChtaW4taGVpZ2h0OiA3NjhweCl7XG4gICAgOmhvc3R7XG4gICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgICAgICBtYXJnaW4tdG9wOiAtNGVtO1xuICAgIH1cbn0iXX0= */");

/***/ }),

/***/ "./src/app/component/btnfinish/btnfinish.component.ts":
/*!************************************************************!*\
  !*** ./src/app/component/btnfinish/btnfinish.component.ts ***!
  \************************************************************/
/*! exports provided: BtnfinishComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BtnfinishComponent", function() { return BtnfinishComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let BtnfinishComponent = class BtnfinishComponent {
    constructor() { }
    ngOnInit() {
    }
};
BtnfinishComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'btnfinish',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./btnfinish.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/btnfinish/btnfinish.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./btnfinish.component.css */ "./src/app/component/btnfinish/btnfinish.component.css")).default]
    })
], BtnfinishComponent);



/***/ }),

/***/ "./src/app/component/chart-data/chart-data.component.css":
/*!***************************************************************!*\
  !*** ./src/app/component/chart-data/chart-data.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\ncanvas{\n    width: 24em;\n    height: 24em;\n    right: 1%;\n    position: absolute;\n    cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2NoYXJ0LWRhdGEvY2hhcnQtZGF0YS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTtJQUNJLFdBQVc7SUFDWCxZQUFZO0lBQ1osU0FBUztJQUNULGtCQUFrQjtJQUNsQixlQUFlO0FBQ25CIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L2NoYXJ0LWRhdGEvY2hhcnQtZGF0YS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG5jYW52YXN7XG4gICAgd2lkdGg6IDI0ZW07XG4gICAgaGVpZ2h0OiAyNGVtO1xuICAgIHJpZ2h0OiAxJTtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/component/chart-data/chart-data.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/component/chart-data/chart-data.component.ts ***!
  \**************************************************************/
/*! exports provided: ChartDataComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChartDataComponent", function() { return ChartDataComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");



let ChartDataComponent = class ChartDataComponent {
    constructor() {
        this.dataPoints = [];
        this.dataColor = [
            "#4891bb",
            "#97991e",
            "#c4640e",
            "#b548a5",
            "#644684"
        ];
        this.countAux = 0;
        this.angle = 17;
        this.index = 3;
        this.clickChartNext = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    set dataPoint(data) {
        this.dataPoints = data;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        const canvasEl = this.canvas.nativeElement;
        this.cx = canvasEl.getContext('2d');
        canvasEl.width = 500;
        canvasEl.height = 500;
        canvasEl.addEventListener("touchend", this.clickChart.bind(this), false);
        canvasEl.addEventListener("click", this.clickChart.bind(this), false);
        this.draw();
    }
    clickChart(event) {
        if (this.subCountTime)
            return;
        const audioRoulette = new Audio('assets/song/ruleta.wav');
        audioRoulette.play();
        const countTime = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["interval"])(13);
        this.subCountTime = countTime.subscribe((n) => {
            this.angle = -1;
            this.countAux++;
            this.draw();
            if (this.countAux >= 72) {
                this.countAux = 0;
                this.subCountTime.unsubscribe();
                this.subCountTime = undefined;
            }
        });
        this.index++;
        this.index = this.index % 5;
        this.clickChartNext.emit(this.index);
    }
    drawPoints() {
        this.drawLine(this.dataPoints);
        this.drawPoint(this.dataPoints);
    }
    draw() {
        this.cx.clearRect(0, 0, 500, 500);
        this.cx.translate(250, 250);
        this.cx.rotate(this.angle * Math.PI / 180);
        this.cx.translate(-250, -250);
        var ini = 0;
        var end = 72;
        this.dataColor.forEach(color => {
            this.cx.beginPath();
            this.cx.moveTo(500 / 2, 500 / 2);
            this.cx.arc(500 / 2, 500 / 2, 250, this.getDegrees(ini), this.getDegrees(end), false);
            this.cx.closePath();
            this.cx.fillStyle = color;
            this.cx.fill();
            ini = end;
            end += 72;
        });
        this.cx.beginPath();
        this.cx.arc(500 / 2, 500 / 2, 167, 0, 2 * Math.PI, false);
        this.cx.closePath();
        this.cx.fillStyle = "#ffffff59";
        this.cx.fill();
        this.cx.beginPath();
        this.cx.arc(500 / 2, 500 / 2, 83, 0, 2 * Math.PI, false);
        this.cx.closePath();
        this.cx.fillStyle = "#ffffff59";
        this.cx.fill();
        this.cx.beginPath();
        this.cx.arc(500 / 2, 500 / 2, 15, 0, 2 * Math.PI, false);
        this.cx.fillStyle = "#b2b2b2";
        this.cx.lineWidth = 5;
        this.cx.strokeStyle = '#717171';
        this.cx.stroke();
        this.cx.fill();
        this.cx.closePath();
        this.cx.beginPath();
        this.cx.arc(135, 130, 60, (200 * Math.PI / 180), (250 * Math.PI / 180), false);
        this.cx.fillStyle = "#4891bb";
        this.cx.stroke();
        this.cx.closePath();
        this.cx.beginPath();
        this.cx.moveTo(93, 103);
        this.cx.lineTo(78.5, 110);
        this.cx.lineTo(75, 95);
        this.cx.stroke();
        this.cx.closePath();
        this.cx.save();
        this.cx.translate(15, 80);
        this.cx.rotate(-45 * Math.PI / 180);
        this.cx.font = "16px sans-serif";
        this.cx.fillStyle = "black";
        this.cx.fillText("Click", 40, 55);
        this.cx.restore();
        this.drawPoints();
    }
    drawPoint(dataPoint) {
        for (var i = 0; i < dataPoint.length; i++) {
            this.cx.beginPath();
            this.cx.arc(dataPoint[i].x, dataPoint[i].y, 10, 0, 2 * Math.PI, false);
            this.cx.closePath();
            this.cx.fillStyle = "#333333";
            this.cx.stroke();
            this.cx.fill();
        }
    }
    drawLine(dataPoint) {
        if (dataPoint.length <= 0)
            return;
        this.cx.beginPath();
        this.cx.moveTo(dataPoint[0].x, dataPoint[0].y);
        for (var i = 1; i < dataPoint.length; i++)
            this.cx.lineTo(dataPoint[i].x, dataPoint[i].y);
        this.cx.lineWidth = 5;
        this.cx.strokeStyle = '#2b4d8b';
        this.cx.closePath();
        this.cx.stroke();
    }
    getDegrees(degres) {
        return (degres * Math.PI / 180);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('canvas', { static: false })
], ChartDataComponent.prototype, "canvas", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ChartDataComponent.prototype, "dataPoint", null);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], ChartDataComponent.prototype, "clickChartNext", void 0);
ChartDataComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'chart-data',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./chart-data.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/chart-data/chart-data.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./chart-data.component.css */ "./src/app/component/chart-data/chart-data.component.css")).default]
    })
], ChartDataComponent);



/***/ }),

/***/ "./src/app/component/chart-info/chart-info.component.css":
/*!***************************************************************!*\
  !*** ./src/app/component/chart-info/chart-info.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nimg{\n    position: absolute;\n    right: 6em;\n    bottom: -2.5em;\n    z-index: -999;\n\n}\n\n@media(max-width: 935px) and (max-height: 750px), (max-width: 935px) and  (min-height: 750px) {\n    img{\n        position: relative;\n        right: 12.5em;\n    }\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2NoYXJ0LWluZm8vY2hhcnQtaW5mby5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTtJQUNJLGtCQUFrQjtJQUNsQixVQUFVO0lBQ1YsY0FBYztJQUNkLGFBQWE7O0FBRWpCOztBQUVBO0lBQ0k7UUFDSSxrQkFBa0I7UUFDbEIsYUFBYTtJQUNqQjtBQUNKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L2NoYXJ0LWluZm8vY2hhcnQtaW5mby5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG5pbWd7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHJpZ2h0OiA2ZW07XG4gICAgYm90dG9tOiAtMi41ZW07XG4gICAgei1pbmRleDogLTk5OTtcblxufVxuXG5AbWVkaWEobWF4LXdpZHRoOiA5MzVweCkgYW5kIChtYXgtaGVpZ2h0OiA3NTBweCksIChtYXgtd2lkdGg6IDkzNXB4KSBhbmQgIChtaW4taGVpZ2h0OiA3NTBweCkge1xuICAgIGltZ3tcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICByaWdodDogMTIuNWVtO1xuICAgIH1cbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/component/chart-info/chart-info.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/component/chart-info/chart-info.component.ts ***!
  \**************************************************************/
/*! exports provided: ChartInfoComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChartInfoComponent", function() { return ChartInfoComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../animation */ "./src/app/animation.ts");



let ChartInfoComponent = class ChartInfoComponent {
    constructor() {
        this.open = false;
    }
    set src(src) {
        this.srcAux = src;
        this.open = false;
    }
    ngOnInit() {
    }
    endFade() {
        this.srcImg = this.srcAux;
    }
    loadImg() {
        this.open = true;
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ChartInfoComponent.prototype, "src", null);
ChartInfoComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'chart-info',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./chart-info.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/chart-info/chart-info.component.html")).default,
        animations: [
            Object(_animation__WEBPACK_IMPORTED_MODULE_2__["fadeBasic"])("1", "0", "0.1s")
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./chart-info.component.css */ "./src/app/component/chart-info/chart-info.component.css")).default]
    })
], ChartInfoComponent);



/***/ }),

/***/ "./src/app/component/img-base/img-base.component.css":
/*!***********************************************************!*\
  !*** ./src/app/component/img-base/img-base.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\nimg{\n    padding-left: 0.5em;\n    height: 100%;\n    width: 100%;\n    padding-top: 1em;\n    max-width: 1101px;\n}\n\n@media(max-width: 935px) and (max-height: 750px), (max-width: 935px) and  (min-height: 750px) {\n    :host{\n        margin-left: 0;\n    }\n    \n    img{\n        padding: 0;\n    }\n}\n\n@media(min-width: 1400px)  {\n    :host{\n        margin-left: 10%;\n    }\n}\n\n@media(min-width: 1800px)  {\n    :host{\n        margin-left: 20%;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2ltZy1iYXNlL2ltZy1iYXNlLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBO0lBQ0ksbUJBQW1CO0lBQ25CLFlBQVk7SUFDWixXQUFXO0lBQ1gsZ0JBQWdCO0lBQ2hCLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJO1FBQ0ksY0FBYztJQUNsQjs7SUFFQTtRQUNJLFVBQVU7SUFDZDtBQUNKOztBQUdBO0lBQ0k7UUFDSSxnQkFBZ0I7SUFDcEI7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksZ0JBQWdCO0lBQ3BCO0FBQ0oiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnQvaW1nLWJhc2UvaW1nLWJhc2UuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIlxuaW1ne1xuICAgIHBhZGRpbmctbGVmdDogMC41ZW07XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIHBhZGRpbmctdG9wOiAxZW07XG4gICAgbWF4LXdpZHRoOiAxMTAxcHg7XG59XG5cbkBtZWRpYShtYXgtd2lkdGg6IDkzNXB4KSBhbmQgKG1heC1oZWlnaHQ6IDc1MHB4KSwgKG1heC13aWR0aDogOTM1cHgpIGFuZCAgKG1pbi1oZWlnaHQ6IDc1MHB4KSB7XG4gICAgOmhvc3R7XG4gICAgICAgIG1hcmdpbi1sZWZ0OiAwO1xuICAgIH1cbiAgICBcbiAgICBpbWd7XG4gICAgICAgIHBhZGRpbmc6IDA7XG4gICAgfVxufVxuXG5cbkBtZWRpYShtaW4td2lkdGg6IDE0MDBweCkgIHtcbiAgICA6aG9zdHtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDEwJTtcbiAgICB9XG59XG5cbkBtZWRpYShtaW4td2lkdGg6IDE4MDBweCkgIHtcbiAgICA6aG9zdHtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDIwJTtcbiAgICB9XG59Il19 */");

/***/ }),

/***/ "./src/app/component/img-base/img-base.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/component/img-base/img-base.component.ts ***!
  \**********************************************************/
/*! exports provided: ImgBaseComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImgBaseComponent", function() { return ImgBaseComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../animation */ "./src/app/animation.ts");



let ImgBaseComponent = class ImgBaseComponent {
    constructor() {
        this.open = false;
    }
    set src(src) {
        this.srcAux = src;
        this.open = false;
    }
    ngOnInit() {
    }
    endFade() {
        this.srcImg = this.srcAux;
    }
    loadImg() {
        this.open = true;
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ImgBaseComponent.prototype, "src", null);
ImgBaseComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'img-base',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./img-base.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/img-base/img-base.component.html")).default,
        animations: [
            Object(_animation__WEBPACK_IMPORTED_MODULE_2__["fadeBasic"])("1", "0", "0.1s")
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./img-base.component.css */ "./src/app/component/img-base/img-base.component.css")).default]
    })
], ImgBaseComponent);



/***/ }),

/***/ "./src/app/component/label-next/label-next.component.css":
/*!***************************************************************!*\
  !*** ./src/app/component/label-next/label-next.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n    position: absolute;\n    width: 18em;\n    height: 5em;\n    right: 1em;\n    bottom: 12em;\n    margin-right: -1em;\n    border-top-left-radius: 1em;\n    border-bottom-left-radius: 1em;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\nspan{\n    font-size: 1.2em;\n    padding-left: 2em;\n    padding-right: 1em;\n    color: var(--text-dark);\n}\n\n@media (max-height: 767px){\n    .container{\n        position: relative;\n        margin-top: 13em;\n        margin-left: auto;\n    }\n}\n\n@media (min-width: 865px) and (max-width: 1024px) and (min-height: 768px){\n    .container{\n        position: relative;\n        margin-top: 13em;\n        margin-left: auto;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2xhYmVsLW5leHQvbGFiZWwtbmV4dC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksa0JBQWtCO0lBQ2xCLFdBQVc7SUFDWCxXQUFXO0lBQ1gsVUFBVTtJQUNWLFlBQVk7SUFDWixrQkFBa0I7SUFDbEIsMkJBQTJCO0lBQzNCLDhCQUE4QjtJQUM5QixhQUFhO0lBQ2IsbUJBQW1CO0lBQ25CLHlCQUF5QjtBQUM3Qjs7QUFFQTtJQUNJLGdCQUFnQjtJQUNoQixpQkFBaUI7SUFDakIsa0JBQWtCO0lBQ2xCLHVCQUF1QjtBQUMzQjs7QUFFQTtJQUNJO1FBQ0ksa0JBQWtCO1FBQ2xCLGdCQUFnQjtRQUNoQixpQkFBaUI7SUFDckI7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksa0JBQWtCO1FBQ2xCLGdCQUFnQjtRQUNoQixpQkFBaUI7SUFDckI7QUFDSiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudC9sYWJlbC1uZXh0L2xhYmVsLW5leHQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXJ7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHdpZHRoOiAxOGVtO1xuICAgIGhlaWdodDogNWVtO1xuICAgIHJpZ2h0OiAxZW07XG4gICAgYm90dG9tOiAxMmVtO1xuICAgIG1hcmdpbi1yaWdodDogLTFlbTtcbiAgICBib3JkZXItdG9wLWxlZnQtcmFkaXVzOiAxZW07XG4gICAgYm9yZGVyLWJvdHRvbS1sZWZ0LXJhZGl1czogMWVtO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuXG5zcGFue1xuICAgIGZvbnQtc2l6ZTogMS4yZW07XG4gICAgcGFkZGluZy1sZWZ0OiAyZW07XG4gICAgcGFkZGluZy1yaWdodDogMWVtO1xuICAgIGNvbG9yOiB2YXIoLS10ZXh0LWRhcmspO1xufVxuXG5AbWVkaWEgKG1heC1oZWlnaHQ6IDc2N3B4KXtcbiAgICAuY29udGFpbmVye1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIG1hcmdpbi10b3A6IDEzZW07XG4gICAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDg2NXB4KSBhbmQgKG1heC13aWR0aDogMTAyNHB4KSBhbmQgKG1pbi1oZWlnaHQ6IDc2OHB4KXtcbiAgICAuY29udGFpbmVye1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIG1hcmdpbi10b3A6IDEzZW07XG4gICAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgIH1cbn0iXX0= */");

/***/ }),

/***/ "./src/app/component/label-next/label-next.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/component/label-next/label-next.component.ts ***!
  \**************************************************************/
/*! exports provided: LabelNextComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelNextComponent", function() { return LabelNextComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LabelNextComponent = class LabelNextComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], LabelNextComponent.prototype, "color", void 0);
LabelNextComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'label-next',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./label-next.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/label-next/label-next.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./label-next.component.css */ "./src/app/component/label-next/label-next.component.css")).default]
    })
], LabelNextComponent);



/***/ }),

/***/ "./src/app/component/line-question/line-question.component.css":
/*!*********************************************************************!*\
  !*** ./src/app/component/line-question/line-question.component.css ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n    position: fixed;\n    display: flex;\n    width: 100%;\n    height: 2em;\n    bottom: 0.5%;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--primary-color);\n}\n\n.circle-max{\n    display: flex;\n    height: 2.5em;\n    width: 2.5em;\n    margin-left: 1% !important;\n    border-radius: 50%;\n    background-color: bisque;\n    margin-left: -1.5em;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.circle-min{\n    height: 0.7em;\n    width: 0.7em;\n    border-radius: 50%;\n    background-color: white;\n}\n\n@media (max-height: 767px) {\n    .container{\n        position: relative;\n        bottom: 0;\n    }\n}\n\n@media (min-width: 865px) and (max-width: 1024px) and (min-height: 768px){\n    .container{\n        position: relative;\n        bottom: 0;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2xpbmUtcXVlc3Rpb24vbGluZS1xdWVzdGlvbi5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksZUFBZTtJQUNmLGFBQWE7SUFDYixXQUFXO0lBQ1gsV0FBVztJQUNYLFlBQVk7SUFDWixtQkFBbUI7SUFDbkIsdUJBQXVCO0lBQ3ZCLHNDQUFzQztBQUMxQzs7QUFFQTtJQUNJLGFBQWE7SUFDYixhQUFhO0lBQ2IsWUFBWTtJQUNaLDBCQUEwQjtJQUMxQixrQkFBa0I7SUFDbEIsd0JBQXdCO0lBQ3hCLG1CQUFtQjtJQUNuQixtQkFBbUI7SUFDbkIsdUJBQXVCO0lBQ3ZCLGVBQWU7QUFDbkI7O0FBRUE7SUFDSSxhQUFhO0lBQ2IsWUFBWTtJQUNaLGtCQUFrQjtJQUNsQix1QkFBdUI7QUFDM0I7O0FBRUE7SUFDSTtRQUNJLGtCQUFrQjtRQUNsQixTQUFTO0lBQ2I7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksa0JBQWtCO1FBQ2xCLFNBQVM7SUFDYjtBQUNKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L2xpbmUtcXVlc3Rpb24vbGluZS1xdWVzdGlvbi5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRhaW5lcntcbiAgICBwb3NpdGlvbjogZml4ZWQ7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDJlbTtcbiAgICBib3R0b206IDAuNSU7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1wcmltYXJ5LWNvbG9yKTtcbn1cblxuLmNpcmNsZS1tYXh7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBoZWlnaHQ6IDIuNWVtO1xuICAgIHdpZHRoOiAyLjVlbTtcbiAgICBtYXJnaW4tbGVmdDogMSUgIWltcG9ydGFudDtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogYmlzcXVlO1xuICAgIG1hcmdpbi1sZWZ0OiAtMS41ZW07XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbi5jaXJjbGUtbWlue1xuICAgIGhlaWdodDogMC43ZW07XG4gICAgd2lkdGg6IDAuN2VtO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZTtcbn1cblxuQG1lZGlhIChtYXgtaGVpZ2h0OiA3NjdweCkge1xuICAgIC5jb250YWluZXJ7XG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgYm90dG9tOiAwO1xuICAgIH1cbn1cblxuQG1lZGlhIChtaW4td2lkdGg6IDg2NXB4KSBhbmQgKG1heC13aWR0aDogMTAyNHB4KSBhbmQgKG1pbi1oZWlnaHQ6IDc2OHB4KXtcbiAgICAuY29udGFpbmVye1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIGJvdHRvbTogMDtcbiAgICB9XG59Il19 */");

/***/ }),

/***/ "./src/app/component/line-question/line-question.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/component/line-question/line-question.component.ts ***!
  \********************************************************************/
/*! exports provided: LineQuestionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LineQuestionComponent", function() { return LineQuestionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LineQuestionComponent = class LineQuestionComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], LineQuestionComponent.prototype, "listColors", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], LineQuestionComponent.prototype, "postLine", void 0);
LineQuestionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'line-question',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./line-question.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/line-question/line-question.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./line-question.component.css */ "./src/app/component/line-question/line-question.component.css")).default]
    })
], LineQuestionComponent);



/***/ }),

/***/ "./src/app/component/loader-msg/loader-msg.component.css":
/*!***************************************************************!*\
  !*** ./src/app/component/loader-msg/loader-msg.component.css ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".modal{\n    display: block;\n    position: fixed;\n    z-index: 200;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    background-color: var(--primary-color);\n}\n\n.logo{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 8em;\n    height: 8em;\n    border-radius: 50%;\n    margin-top: -4em;\n    margin-left: -4em;\n \n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    background-image: url('logo.png');\n    background-color: white;\n\n    -webkit-animation-name: pulse-scale;\n\n            animation-name: pulse-scale;\n    -webkit-animation-duration: 1.5s;\n            animation-duration: 1.5s;\n    -webkit-animation-timing-function: linear;\n            animation-timing-function: linear;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L2xvYWRlci1tc2cvbG9hZGVyLW1zZy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksY0FBYztJQUNkLGVBQWU7SUFDZixZQUFZO0lBQ1osT0FBTztJQUNQLE1BQU07SUFDTixXQUFXO0lBQ1gsWUFBWTtJQUNaLGdCQUFnQjtJQUNoQixzQ0FBc0M7QUFDMUM7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsUUFBUTtJQUNSLFNBQVM7SUFDVCxVQUFVO0lBQ1YsV0FBVztJQUNYLGtCQUFrQjtJQUNsQixnQkFBZ0I7SUFDaEIsaUJBQWlCOztJQUVqQiw0QkFBNEI7SUFDNUIsMEJBQTBCO0lBQzFCLGlDQUFpRDtJQUNqRCx1QkFBdUI7O0lBRXZCLG1DQUEyQjs7WUFBM0IsMkJBQTJCO0lBQzNCLGdDQUF3QjtZQUF4Qix3QkFBd0I7SUFDeEIseUNBQWlDO1lBQWpDLGlDQUFpQztJQUNqQywyQ0FBbUM7WUFBbkMsbUNBQW1DO0FBQ3ZDIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L2xvYWRlci1tc2cvbG9hZGVyLW1zZy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm1vZGFse1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIHBvc2l0aW9uOiBmaXhlZDtcbiAgICB6LWluZGV4OiAyMDA7XG4gICAgbGVmdDogMDtcbiAgICB0b3A6IDA7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tcHJpbWFyeS1jb2xvcik7XG59XG5cbi5sb2dve1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDUwJTtcbiAgICBsZWZ0OiA1MCU7XG4gICAgd2lkdGg6IDhlbTtcbiAgICBoZWlnaHQ6IDhlbTtcbiAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgbWFyZ2luLXRvcDogLTRlbTtcbiAgICBtYXJnaW4tbGVmdDogLTRlbTtcbiBcbiAgICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICAgIGJhY2tncm91bmQtc2l6ZTogMTAwJSAxMDAlO1xuICAgIGJhY2tncm91bmQtaW1hZ2U6IHVybCgnc3JjL2Fzc2V0cy9wbGF5L2xvZ28ucG5nJyk7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7XG5cbiAgICBhbmltYXRpb24tbmFtZTogcHVsc2Utc2NhbGU7XG4gICAgYW5pbWF0aW9uLWR1cmF0aW9uOiAxLjVzO1xuICAgIGFuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246IGxpbmVhcjtcbiAgICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiBpbmZpbml0ZTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/component/loader-msg/loader-msg.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/component/loader-msg/loader-msg.component.ts ***!
  \**************************************************************/
/*! exports provided: LoaderMsgComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoaderMsgComponent", function() { return LoaderMsgComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let LoaderMsgComponent = class LoaderMsgComponent {
    constructor() { }
    ngOnInit() {
    }
};
LoaderMsgComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'loader-msg',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./loader-msg.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/loader-msg/loader-msg.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./loader-msg.component.css */ "./src/app/component/loader-msg/loader-msg.component.css")).default]
    })
], LoaderMsgComponent);



/***/ }),

/***/ "./src/app/component/msg-box/msg-box.component.css":
/*!*********************************************************!*\
  !*** ./src/app/component/msg-box/msg-box.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".modal{\n    display: block;\n    position: fixed;\n    z-index: 999;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n}\n\n.modal-content {\n    background-color: #fefefe;\n    margin: 15% auto;\n    padding: 20px;\n    width: 300px;\n    height: auto;\n    border-radius: 10px;\n}\n\n.text{\n    font-size: 1.5em;\n    text-align: center;\n}\n\n.btn{\n    font-size: 1.5em;\n    margin: auto;\n    margin-top: 1em;\n    height: 2em;\n    width: 50%;\n    border-radius: 5em;\n    text-align: center;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-dark);\n}\n\n.btn:hover{\n    cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L21zZy1ib3gvbXNnLWJveC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksY0FBYztJQUNkLGVBQWU7SUFDZixZQUFZO0lBQ1osT0FBTztJQUNQLE1BQU07SUFDTixXQUFXO0lBQ1gsWUFBWTtJQUNaLGNBQWM7SUFDZCxpQ0FBaUMsRUFBRSxxQkFBcUI7QUFDNUQ7O0FBRUE7SUFDSSx5QkFBeUI7SUFDekIsZ0JBQWdCO0lBQ2hCLGFBQWE7SUFDYixZQUFZO0lBQ1osWUFBWTtJQUNaLG1CQUFtQjtBQUN2Qjs7QUFFQTtJQUNJLGdCQUFnQjtJQUNoQixrQkFBa0I7QUFDdEI7O0FBRUE7SUFDSSxnQkFBZ0I7SUFDaEIsWUFBWTtJQUNaLGVBQWU7SUFDZixXQUFXO0lBQ1gsVUFBVTtJQUNWLGtCQUFrQjtJQUNsQixrQkFBa0I7O0lBRWxCLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsdUJBQXVCO0lBQ3ZCLHVCQUF1QjtBQUMzQjs7QUFFQTtJQUNJLGVBQWU7QUFDbkIiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnQvbXNnLWJveC9tc2ctYm94LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubW9kYWx7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgcG9zaXRpb246IGZpeGVkO1xuICAgIHotaW5kZXg6IDk5OTtcbiAgICBsZWZ0OiAwO1xuICAgIHRvcDogMDtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgb3ZlcmZsb3c6IGF1dG87XG4gICAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgwLDAsMCwwLjQpOyAvKiBCbGFjayB3LyBvcGFjaXR5ICovXG59XG5cbi5tb2RhbC1jb250ZW50IHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmVmZWZlO1xuICAgIG1hcmdpbjogMTUlIGF1dG87XG4gICAgcGFkZGluZzogMjBweDtcbiAgICB3aWR0aDogMzAwcHg7XG4gICAgaGVpZ2h0OiBhdXRvO1xuICAgIGJvcmRlci1yYWRpdXM6IDEwcHg7XG59XG5cbi50ZXh0e1xuICAgIGZvbnQtc2l6ZTogMS41ZW07XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4uYnRue1xuICAgIGZvbnQtc2l6ZTogMS41ZW07XG4gICAgbWFyZ2luOiBhdXRvO1xuICAgIG1hcmdpbi10b3A6IDFlbTtcbiAgICBoZWlnaHQ6IDJlbTtcbiAgICB3aWR0aDogNTAlO1xuICAgIGJvcmRlci1yYWRpdXM6IDVlbTtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG5cbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgY29sb3I6IHZhcigtLXRleHQtZGFyayk7XG59XG5cbi5idG46aG92ZXJ7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/component/msg-box/msg-box.component.ts":
/*!********************************************************!*\
  !*** ./src/app/component/msg-box/msg-box.component.ts ***!
  \********************************************************/
/*! exports provided: MsgBoxComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MsgBoxComponent", function() { return MsgBoxComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let MsgBoxComponent = class MsgBoxComponent {
    constructor() {
        this.clickClose = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
    }
    click() {
        this.clickClose.emit();
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], MsgBoxComponent.prototype, "color", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], MsgBoxComponent.prototype, "clickClose", void 0);
MsgBoxComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'msg-box',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./msg-box.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/msg-box/msg-box.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./msg-box.component.css */ "./src/app/component/msg-box/msg-box.component.css")).default]
    })
], MsgBoxComponent);



/***/ }),

/***/ "./src/app/component/question-form/question-form.component.css":
/*!*********************************************************************!*\
  !*** ./src/app/component/question-form/question-form.component.css ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n    margin-top: 1%;\n}\n\nanswer{\n    margin: auto;\n    margin-top: 3%;\n    border: 2px solid;\n    border-radius: 1em;\n    cursor: pointer;\n}\n\nbtnfinish{\n    height: 3.5em;\n    width: 12em;\n}\n\n.pulse-btn-next{\n    -webkit-animation-name: pulse-scale;\n            animation-name: pulse-scale;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-timing-function: linear;\n            animation-timing-function: linear;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n}\n\n@media (max-width: 500px){\n    answer{\n        height: auto;\n    }\n}\n\n@media (max-width: 1023px){\n    answer{\n        margin-top: 5%;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L3F1ZXN0aW9uLWZvcm0vcXVlc3Rpb24tZm9ybS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksY0FBYztBQUNsQjs7QUFFQTtJQUNJLFlBQVk7SUFDWixjQUFjO0lBQ2QsaUJBQWlCO0lBQ2pCLGtCQUFrQjtJQUNsQixlQUFlO0FBQ25COztBQUVBO0lBQ0ksYUFBYTtJQUNiLFdBQVc7QUFDZjs7QUFFQTtJQUNJLG1DQUEyQjtZQUEzQiwyQkFBMkI7SUFDM0IsOEJBQXNCO1lBQXRCLHNCQUFzQjtJQUN0Qix5Q0FBaUM7WUFBakMsaUNBQWlDO0lBQ2pDLDJDQUFtQztZQUFuQyxtQ0FBbUM7QUFDdkM7O0FBRUE7SUFDSTtRQUNJLFlBQVk7SUFDaEI7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksY0FBYztJQUNsQjtBQUNKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L3F1ZXN0aW9uLWZvcm0vcXVlc3Rpb24tZm9ybS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRhaW5lcntcbiAgICBtYXJnaW4tdG9wOiAxJTtcbn1cblxuYW5zd2Vye1xuICAgIG1hcmdpbjogYXV0bztcbiAgICBtYXJnaW4tdG9wOiAzJTtcbiAgICBib3JkZXI6IDJweCBzb2xpZDtcbiAgICBib3JkZXItcmFkaXVzOiAxZW07XG4gICAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG5idG5maW5pc2h7XG4gICAgaGVpZ2h0OiAzLjVlbTtcbiAgICB3aWR0aDogMTJlbTtcbn1cblxuLnB1bHNlLWJ0bi1uZXh0e1xuICAgIGFuaW1hdGlvbi1uYW1lOiBwdWxzZS1zY2FsZTtcbiAgICBhbmltYXRpb24tZHVyYXRpb246IDJzO1xuICAgIGFuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246IGxpbmVhcjtcbiAgICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiBpbmZpbml0ZTtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDUwMHB4KXtcbiAgICBhbnN3ZXJ7XG4gICAgICAgIGhlaWdodDogYXV0bztcbiAgICB9XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiAxMDIzcHgpe1xuICAgIGFuc3dlcntcbiAgICAgICAgbWFyZ2luLXRvcDogNSU7XG4gICAgfVxufSJdfQ== */");

/***/ }),

/***/ "./src/app/component/question-form/question-form.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/component/question-form/question-form.component.ts ***!
  \********************************************************************/
/*! exports provided: QuestionFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionFormComponent", function() { return QuestionFormComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_color_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../service/color.service */ "./src/app/service/color.service.ts");



let QuestionFormComponent = class QuestionFormComponent {
    constructor(colors) {
        this.colors = colors;
        this.selectAnswer = [false, false, false];
        this.indexAnswer = -1;
        this.classAnimation = "";
        this.openMsgBox = false;
        this.indexQuestion = 0;
        this.indexColor = 0;
        this.clickNextQuestion = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
        this.init();
    }
    init() {
        this.listColorLine = this.colors.getListColors();
        this.listColorMain = this.colors.getListMainColors();
    }
    clickAnswer(index) {
        const audioSelectAnswer = new Audio('assets/song/selectAnswer.wav');
        audioSelectAnswer.play();
        this.selectAnswer.fill(false);
        this.selectAnswer[index] = true;
        this.indexAnswer = index;
        this.classAnimation = "pulse-btn-next";
    }
    clickNext() {
        if (!this.validateSelectQuestion()) {
            //alert("Debe selecionar al menos una de las opciones.");
            this.openMsgBox = true;
            return;
        }
        this.clickNextQuestion.emit(this.indexAnswer);
        this.restart();
    }
    validateSelectQuestion() {
        let isSelect = this.selectAnswer.find(elm => {
            return elm == true;
        });
        return (isSelect);
    }
    restart() {
        this.selectAnswer.fill(false);
        this.indexAnswer = -1;
        this.classAnimation = "";
    }
    clickMsgBox() {
        this.openMsgBox = false;
    }
};
QuestionFormComponent.ctorParameters = () => [
    { type: _service_color_service__WEBPACK_IMPORTED_MODULE_2__["ColorService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], QuestionFormComponent.prototype, "indexQuestion", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], QuestionFormComponent.prototype, "indexColor", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], QuestionFormComponent.prototype, "question", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], QuestionFormComponent.prototype, "clickNextQuestion", void 0);
QuestionFormComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'question-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./question-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/question-form/question-form.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./question-form.component.css */ "./src/app/component/question-form/question-form.component.css")).default]
    })
], QuestionFormComponent);



/***/ }),

/***/ "./src/app/component/question/question.component.css":
/*!***********************************************************!*\
  !*** ./src/app/component/question/question.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n    width: 60%;\n    height: 100%;\n}\n\n.bar-top{\n    display: flex;\n    height: 3em;\n    border-top-right-radius: 0.5em;\n    align-items: center;\n    justify-content: flex-end;\n    background-color: var(--primary-color);\n}\n\n.bar-bottom{\n    display: flex;\n    height: 10em;\n    border-bottom-right-radius: 2em;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.text-bar-top {\n    font-weight: bold;\n    color: var(--text-light);\n    font-size: 2em;\n    margin-right: 1em;\n}\n\n.text-bar-bottom{\n    width: 15em;\n    font-weight: bold;\n    color: var(--text-dark);\n    font-size: 2.5em;\n    margin-right: 1em;\n    text-align: right;\n}\n\n@media (max-width: 500px){\n    .bar-bottom{\n        min-height: 10em;\n        height: auto;\n    }\n}\n\n@media (max-width: 1023px){\n    .container{\n        width: 90%;\n        height: auto;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L3F1ZXN0aW9uL3F1ZXN0aW9uLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxVQUFVO0lBQ1YsWUFBWTtBQUNoQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixXQUFXO0lBQ1gsOEJBQThCO0lBQzlCLG1CQUFtQjtJQUNuQix5QkFBeUI7SUFDekIsc0NBQXNDO0FBQzFDOztBQUVBO0lBQ0ksYUFBYTtJQUNiLFlBQVk7SUFDWiwrQkFBK0I7SUFDL0IsbUJBQW1CO0lBQ25CLHlCQUF5QjtBQUM3Qjs7QUFFQTtJQUNJLGlCQUFpQjtJQUNqQix3QkFBd0I7SUFDeEIsY0FBYztJQUNkLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLFdBQVc7SUFDWCxpQkFBaUI7SUFDakIsdUJBQXVCO0lBQ3ZCLGdCQUFnQjtJQUNoQixpQkFBaUI7SUFDakIsaUJBQWlCO0FBQ3JCOztBQUVBO0lBQ0k7UUFDSSxnQkFBZ0I7UUFDaEIsWUFBWTtJQUNoQjtBQUNKOztBQUVBO0lBQ0k7UUFDSSxVQUFVO1FBQ1YsWUFBWTtJQUNoQjtBQUNKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50L3F1ZXN0aW9uL3F1ZXN0aW9uLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGFpbmVye1xuICAgIHdpZHRoOiA2MCU7XG4gICAgaGVpZ2h0OiAxMDAlO1xufVxuXG4uYmFyLXRvcHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGhlaWdodDogM2VtO1xuICAgIGJvcmRlci10b3AtcmlnaHQtcmFkaXVzOiAwLjVlbTtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tcHJpbWFyeS1jb2xvcik7XG59XG5cbi5iYXItYm90dG9te1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgaGVpZ2h0OiAxMGVtO1xuICAgIGJvcmRlci1ib3R0b20tcmlnaHQtcmFkaXVzOiAyZW07XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuXG4udGV4dC1iYXItdG9wIHtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICBjb2xvcjogdmFyKC0tdGV4dC1saWdodCk7XG4gICAgZm9udC1zaXplOiAyZW07XG4gICAgbWFyZ2luLXJpZ2h0OiAxZW07XG59XG5cbi50ZXh0LWJhci1ib3R0b217XG4gICAgd2lkdGg6IDE1ZW07XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgY29sb3I6IHZhcigtLXRleHQtZGFyayk7XG4gICAgZm9udC1zaXplOiAyLjVlbTtcbiAgICBtYXJnaW4tcmlnaHQ6IDFlbTtcbiAgICB0ZXh0LWFsaWduOiByaWdodDtcbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDUwMHB4KXtcbiAgICAuYmFyLWJvdHRvbXtcbiAgICAgICAgbWluLWhlaWdodDogMTBlbTtcbiAgICAgICAgaGVpZ2h0OiBhdXRvO1xuICAgIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDEwMjNweCl7XG4gICAgLmNvbnRhaW5lcntcbiAgICAgICAgd2lkdGg6IDkwJTtcbiAgICAgICAgaGVpZ2h0OiBhdXRvO1xuICAgIH1cbn0iXX0= */");

/***/ }),

/***/ "./src/app/component/question/question.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/component/question/question.component.ts ***!
  \**********************************************************/
/*! exports provided: QuestionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionComponent", function() { return QuestionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let QuestionComponent = class QuestionComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], QuestionComponent.prototype, "color", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], QuestionComponent.prototype, "question", void 0);
QuestionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'question',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./question.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/question/question.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./question.component.css */ "./src/app/component/question/question.component.css")).default]
    })
], QuestionComponent);



/***/ }),

/***/ "./src/app/component/result/result.component.css":
/*!*******************************************************!*\
  !*** ./src/app/component/result/result.component.css ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n.img-main{\n    position: absolute;\n    width: 40%;\n    height: 70%;\n}\n\n.bar-desc{\n    position: absolute;\n    width: 59%;\n    bottom: 11%;\n    height: 15%;\n}\n\n.chart-point{\n    position: absolute;\n    bottom: 1em;\n    right: 1em;\n    height: 50%;\n    width: 40%;\n}\n\n.content-chart{\n    position: absolute;\n    right: 1em;\n    width: 59%;\n    height: 48%;\n}\n\n.btn-home{\n    position: absolute;\n    height: 3em;\n    width: 3em;\n    border-radius: 50%;\n    right: 1em;\n    top: 1em;\n    cursor: pointer;\n\n    background-repeat: no-repeat;\n    background-size: 100% 100%;  \n    background-image: url('home.png');\n}\n\n@media(min-width: 1000px) and (min-height: 1000px)  {\n    :host  { \n        zoom: 125%;\n    }\n}\n\n@media(max-width: 935px) and (max-height: 750px), (max-width: 935px) and  (min-height: 768px){\n    .img-main{\n        display: block;\n        position: relative;\n        width: 30em;\n        height: auto;\n        margin: auto;\n    }\n\n    .content-chart{\n        position: relative;\n        margin-left: auto;\n    }\n\n    .chart-point{\n        position: relative;\n        height: 25em;\n        width: 25em;\n        margin: auto;\n        padding-top: 5em;\n    }\n\n    .bar-desc{\n        position: relative;\n        width: 95%;\n    }\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50L3Jlc3VsdC9yZXN1bHQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQ0E7SUFDSSxrQkFBa0I7SUFDbEIsVUFBVTtJQUNWLFdBQVc7QUFDZjs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixVQUFVO0lBQ1YsV0FBVztJQUNYLFdBQVc7QUFDZjs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixXQUFXO0lBQ1gsVUFBVTtJQUNWLFdBQVc7SUFDWCxVQUFVO0FBQ2Q7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsVUFBVTtJQUNWLFVBQVU7SUFDVixXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsV0FBVztJQUNYLFVBQVU7SUFDVixrQkFBa0I7SUFDbEIsVUFBVTtJQUNWLFFBQVE7SUFDUixlQUFlOztJQUVmLDRCQUE0QjtJQUM1QiwwQkFBMEI7SUFDMUIsaUNBQWlEO0FBQ3JEOztBQUVBO0lBQ0k7UUFDSSxVQUFVO0lBQ2Q7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksY0FBYztRQUNkLGtCQUFrQjtRQUNsQixXQUFXO1FBQ1gsWUFBWTtRQUNaLFlBQVk7SUFDaEI7O0lBRUE7UUFDSSxrQkFBa0I7UUFDbEIsaUJBQWlCO0lBQ3JCOztJQUVBO1FBQ0ksa0JBQWtCO1FBQ2xCLFlBQVk7UUFDWixXQUFXO1FBQ1gsWUFBWTtRQUNaLGdCQUFnQjtJQUNwQjs7SUFFQTtRQUNJLGtCQUFrQjtRQUNsQixVQUFVO0lBQ2Q7QUFDSiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudC9yZXN1bHQvcmVzdWx0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcbi5pbWctbWFpbntcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgd2lkdGg6IDQwJTtcbiAgICBoZWlnaHQ6IDcwJTtcbn1cblxuLmJhci1kZXNje1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB3aWR0aDogNTklO1xuICAgIGJvdHRvbTogMTElO1xuICAgIGhlaWdodDogMTUlO1xufVxuXG4uY2hhcnQtcG9pbnR7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGJvdHRvbTogMWVtO1xuICAgIHJpZ2h0OiAxZW07XG4gICAgaGVpZ2h0OiA1MCU7XG4gICAgd2lkdGg6IDQwJTtcbn1cblxuLmNvbnRlbnQtY2hhcnR7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHJpZ2h0OiAxZW07XG4gICAgd2lkdGg6IDU5JTtcbiAgICBoZWlnaHQ6IDQ4JTtcbn1cblxuLmJ0bi1ob21le1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBoZWlnaHQ6IDNlbTtcbiAgICB3aWR0aDogM2VtO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICByaWdodDogMWVtO1xuICAgIHRvcDogMWVtO1xuICAgIGN1cnNvcjogcG9pbnRlcjtcblxuICAgIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gICAgYmFja2dyb3VuZC1zaXplOiAxMDAlIDEwMCU7ICBcbiAgICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoJ3NyYy9hc3NldHMvcGxheS9ob21lLnBuZycpO1xufVxuXG5AbWVkaWEobWluLXdpZHRoOiAxMDAwcHgpIGFuZCAobWluLWhlaWdodDogMTAwMHB4KSAge1xuICAgIDpob3N0ICB7IFxuICAgICAgICB6b29tOiAxMjUlO1xuICAgIH1cbn1cblxuQG1lZGlhKG1heC13aWR0aDogOTM1cHgpIGFuZCAobWF4LWhlaWdodDogNzUwcHgpLCAobWF4LXdpZHRoOiA5MzVweCkgYW5kICAobWluLWhlaWdodDogNzY4cHgpe1xuICAgIC5pbWctbWFpbntcbiAgICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICAgd2lkdGg6IDMwZW07XG4gICAgICAgIGhlaWdodDogYXV0bztcbiAgICAgICAgbWFyZ2luOiBhdXRvO1xuICAgIH1cblxuICAgIC5jb250ZW50LWNoYXJ0e1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICAgIH1cblxuICAgIC5jaGFydC1wb2ludHtcbiAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICBoZWlnaHQ6IDI1ZW07XG4gICAgICAgIHdpZHRoOiAyNWVtO1xuICAgICAgICBtYXJnaW46IGF1dG87XG4gICAgICAgIHBhZGRpbmctdG9wOiA1ZW07XG4gICAgfVxuXG4gICAgLmJhci1kZXNje1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIHdpZHRoOiA5NSU7XG4gICAgfVxufSJdfQ== */");

/***/ }),

/***/ "./src/app/component/result/result.component.ts":
/*!******************************************************!*\
  !*** ./src/app/component/result/result.component.ts ***!
  \******************************************************/
/*! exports provided: ResultComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResultComponent", function() { return ResultComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_color_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../service/color.service */ "./src/app/service/color.service.ts");
/* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../animation */ "./src/app/animation.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");





let ResultComponent = class ResultComponent {
    constructor(colors, router) {
        this.colors = colors;
        this.router = router;
        this.dataPoints = [];
        this.index = 0;
        this.open = true;
        this.dataPointResult = [];
        this.loadAudio();
    }
    set dataPoint(dataPoint) {
        this.loadPointData(dataPoint);
        this.audioFondo.play();
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.audioFondo.pause();
        this.audioFondo.currentTime = 0;
    }
    addPoints() {
        this.dataPoints.push({
            ref: 'rosado',
            color: this.colors.colorMain[1],
            title: 'Competencia Tecnológica',
            text: 'Capacidad para seleccionar y utilizar de forma pertinente, responsable y eficiente una variedad de herramientas tecnológicas entendiendo los principios que las rigen, la forma de combinarlas y las licencias que las amparan.',
            img: './assets/result/tecnologico.png',
            imgData: './assets/result/CTecnologica.png',
            point: [
                { x: 236, y: 210 },
                { x: 210, y: 130 },
                { x: 185, y: 50 }
            ]
        }, {
            ref: 'morado',
            color: this.colors.colorMain[0],
            title: 'Competencia Comunicativa',
            text: 'Capacidad para expresarse, establecer contacto y relacionarse en espacios virtuales y audiovisuales a través de diversos medios y con el manejo de multiples lenguajes, de manera sincrónica y asincrónica.',
            img: './assets/result/comunicativa.png',
            imgData: './assets/result/CComunicativa.png',
            point: [
                { x: 290, y: 220 },
                { x: 350, y: 175 },
                { x: 425, y: 120 }
            ]
        }, {
            ref: 'azul',
            color: this.colors.colorMain[4],
            title: 'Competencia Investigativa',
            text: 'Capacidad de utilizar las TIC para la transformación del saber y la generación de nuevos conocimientos.',
            img: './assets/result/investigativa.png',
            imgData: './assets/result/CInvestigativa.png',
            point: [
                { x: 290, y: 280 },
                { x: 350, y: 325 },
                { x: 425, y: 381 }
            ]
        }, {
            ref: 'verde',
            color: this.colors.colorMain[2],
            title: 'Competencia de Gestión',
            text: 'Capacidad de utilizar las TIC para la transformación del saber y la generación de nuevos conocimientos.',
            img: './assets/result/gestion.png',
            imgData: './assets/result/CGestion.png',
            point: [
                { x: 235, y: 295 },
                { x: 210, y: 370 },
                { x: 180, y: 455 }
            ]
        }, {
            ref: 'naranja',
            color: this.colors.colorMain[3],
            title: 'Competencia Pedagógica',
            text: 'Capacidad de utilizar las TIC para fortalecer los procesos de enseñanza y aprendizaje, reconociendo alcances y limitaciones de la incorporación de estas tecnologías en la formación integral de los estudiantes y en su propio desarrollo profesional.',
            img: './assets/result/pedagogica.png',
            imgData: './assets/result/CPedagogica.png',
            point: [
                { x: 200, y: 250 },
                { x: 120, y: 250 },
                { x: 35, y: 250 }
            ]
        });
    }
    nextItem(indexChart) {
        switch (indexChart) {
            case 3:
                this.index = 0;
                break;
            case 4:
                this.index = 1;
                break;
            case 0:
                this.index = 2;
                break;
            case 1:
                this.index = 3;
                break;
            case 2:
                this.index = 4;
                break;
        }
    }
    loadPointData(dataPoint) {
        this.addPoints();
        for (let i = 0; i < dataPoint.length; i++)
            this.dataPointResult.push(this.dataPoints[i].point[dataPoint[i]]);
    }
    toHome() {
        this.audioHome.play();
        this.router.navigate(['/home']);
    }
    loadAudio() {
        this.audioHome = new Audio('assets/song/btnL2.wav');
        this.audioFondo = new Audio('assets/song/fondoResultado.wav');
        this.audioFondo.volume = 0.5;
        this.audioFondo.loop = true;
    }
};
ResultComponent.ctorParameters = () => [
    { type: _service_color_service__WEBPACK_IMPORTED_MODULE_2__["ColorService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ResultComponent.prototype, "dataPoint", null);
ResultComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'result',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./result.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/component/result/result.component.html")).default,
        animations: [
            Object(_animation__WEBPACK_IMPORTED_MODULE_3__["fadeBasic"])()
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./result.component.css */ "./src/app/component/result/result.component.css")).default]
    })
], ResultComponent);



/***/ }),

/***/ "./src/app/page/home-page/home-page.component.css":
/*!********************************************************!*\
  !*** ./src/app/page/home-page/home-page.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".container{\n    height: 100vh;\n    width: 100%;\n    background-color: var(--primary-color);\n    display: table;\n}\n\n.content{\n    width: 30em;\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.logo{\n    width: 30em;\n    height: 30em;\n    margin: auto;\n    background-color: white;\n    border-radius: 50%;\n\n    background-repeat: no-repeat;\n    background-size: 100% 100%;  \n    background-image: url('logo.png');\n}\n\n.btn{\n    width: 25em;\n    height: 3em;\n    background-color: #bec023;\n    margin: auto;\n    margin-top: 2em;\n    border-radius: 1em;\n    display: table;\n    cursor: pointer;\n}\n\nspan{\n    font-family: 'Exo 2', sans-serif;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    color: var(--text-light);\n    font-size: 2em;\n}\n\n.info{\n    width: 3em;\n    height: 3em;\n    border-radius: 50%;\n    position: absolute;\n    top: 1em;\n    left: 1em;\n    cursor: pointer;\n\n    background-repeat: no-repeat;\n    background-size: 100% 100%;  \n    background-image: url('info.svg');\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/page/home-page/home-page.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/page/home-page/home-page.component.ts ***!
  \*******************************************************/
/*! exports provided: HomePageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomePageComponent", function() { return HomePageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let HomePageComponent = class HomePageComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        this.loadAudio();
        this.preload();
    }
    ngOnDestroy() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.audioFondo.pause();
            this.audioFondo.currentTime = 0;
        });
    }
    clickPlay() {
        this.audioPlay.play();
        this.audioFondo.pause();
        this.audioFondo.currentTime = 0;
        this.router.navigate(['/play']);
    }
    clickInfo() {
    }
    loadAudio() {
        this.audioPlay = new Audio('assets/song/btnL.wav');
        this.audioFondo = new Audio('assets/song/fondoMenu.wav');
        this.audioFondo.volume = 0.25;
        this.audioFondo.loop = true;
        setTimeout((function () {
            this.audioFondo.play();
        }), 1000);
    }
    playAudio() {
        console.log('event');
        if (this.audioFondo.paused)
            this.audioFondo.play();
    }
    preload() {
        let urls = ["./assets/result/tecnologico.png",
            "./assets/result/CTecnologica.png",
            "./assets/result/comunicativa.png",
            "./assets/result/CComunicativa.png",
            "./assets/result/investigativa.png",
            "./assets/result/CInvestigativa.png",
            "./assets/result/gestion.png",
            "./assets/result/CGestion.png",
            "./assets/result/pedagogica.png",
            "./assets/result/CPedagogica.png"];
        for (var i = 0; i < urls.length; i++) {
            let img = new Image();
            img.src = urls[i];
        }
    }
};
HomePageComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
HomePageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/page/home-page/home-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home-page.component.css */ "./src/app/page/home-page/home-page.component.css")).default]
    })
], HomePageComponent);



/***/ }),

/***/ "./src/app/page/play-page/play-page.component.css":
/*!********************************************************!*\
  !*** ./src/app/page/play-page/play-page.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n\n@media (max-width: 1150px) { \n    :host { \n        zoom: 95%; \n    } \n}\n\n@media (max-width: 1000px) { \n    :host  { \n        zoom: 90%; \n    } \n}\n\n@media (max-width: 950px) { \n    :host  { \n        zoom: 80%; \n    } \n}\n\n@media(max-width: 1240px) and (max-height: 720px)  {\n    :host  { \n        zoom: 70%;\n    } \n}\n\n@media(min-width: 1200px) and (min-height: 1080px)  {\n    :host  { \n        zoom: 120%;\n    } \n}\n\n@media(min-width: 2550px) and (min-height: 1440px)  {\n    :host  { \n        zoom: 150%;\n    } \n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZS9wbGF5LXBhZ2UvcGxheS1wYWdlLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTtJQUNJO1FBQ0ksU0FBUztJQUNiO0FBQ0o7O0FBRUE7SUFDSTtRQUNJLFNBQVM7SUFDYjtBQUNKOztBQUVBO0lBQ0k7UUFDSSxTQUFTO0lBQ2I7QUFDSjs7QUFFQTtJQUNJO1FBQ0ksU0FBUztJQUNiO0FBQ0o7O0FBRUE7SUFDSTtRQUNJLFVBQVU7SUFDZDtBQUNKOztBQUVBO0lBQ0k7UUFDSSxVQUFVO0lBQ2Q7QUFDSiIsImZpbGUiOiJzcmMvYXBwL3BhZ2UvcGxheS1wYWdlL3BsYXktcGFnZS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG5cbkBtZWRpYSAobWF4LXdpZHRoOiAxMTUwcHgpIHsgXG4gICAgOmhvc3QgeyBcbiAgICAgICAgem9vbTogOTUlOyBcbiAgICB9IFxufVxuXG5AbWVkaWEgKG1heC13aWR0aDogMTAwMHB4KSB7IFxuICAgIDpob3N0ICB7IFxuICAgICAgICB6b29tOiA5MCU7IFxuICAgIH0gXG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiA5NTBweCkgeyBcbiAgICA6aG9zdCAgeyBcbiAgICAgICAgem9vbTogODAlOyBcbiAgICB9IFxufVxuXG5AbWVkaWEobWF4LXdpZHRoOiAxMjQwcHgpIGFuZCAobWF4LWhlaWdodDogNzIwcHgpICB7XG4gICAgOmhvc3QgIHsgXG4gICAgICAgIHpvb206IDcwJTtcbiAgICB9IFxufVxuXG5AbWVkaWEobWluLXdpZHRoOiAxMjAwcHgpIGFuZCAobWluLWhlaWdodDogMTA4MHB4KSAge1xuICAgIDpob3N0ICB7IFxuICAgICAgICB6b29tOiAxMjAlO1xuICAgIH0gXG59XG5cbkBtZWRpYShtaW4td2lkdGg6IDI1NTBweCkgYW5kIChtaW4taGVpZ2h0OiAxNDQwcHgpICB7XG4gICAgOmhvc3QgIHsgXG4gICAgICAgIHpvb206IDE1MCU7XG4gICAgfSBcbn0iXX0= */");

/***/ }),

/***/ "./src/app/page/play-page/play-page.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/page/play-page/play-page.component.ts ***!
  \*******************************************************/
/*! exports provided: PlayPageComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlayPageComponent", function() { return PlayPageComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_play_data_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../service/play-data.service */ "./src/app/service/play-data.service.ts");
/* harmony import */ var _service_url_default_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../../service/url-default.service */ "./src/app/service/url-default.service.ts");




let PlayPageComponent = class PlayPageComponent {
    constructor(playService, dataSource) {
        this.playService = playService;
        this.dataSource = dataSource;
        this.isLoader = false;
        this.isFinishQuestion = false; // cambiar en produccion
        this.indexQuestion = 0;
        this.indexColor = 0;
        this.scoreCategory = [0, 0, 0, 0, 0];
        this.answerQuestion = [];
        this.resultQuestion = [0, 0, 0, 0, 0];
        this.loadAudio();
    }
    ngOnInit() {
        this.init();
    }
    ngOnDestroy() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.audioFondo.pause();
            this.audioFondo.currentTime = 0;
        });
    }
    init() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.dataSource.ExternalFileConfig();
            this.questionList = yield this.playService.getQuestion();
            this.questionMain = this.questionList[0];
            this.isLoader = true;
            this.audioFondo.play();
        });
    }
    nextQuestion(indexAnswer) {
        this.answerQuestion.push(indexAnswer);
        this.scoreCategory[this.getIndexCategory(this.questionMain.category)] += this.questionMain.answer[indexAnswer].score;
        this.indexQuestion++;
        if (this.indexQuestion >= 15) {
            this.audioResult.play();
            this.audioFondo.pause();
            this.audioFondo.currentTime = 0;
            this.calculatedValueCategory();
            this.isFinishQuestion = true;
            return;
        }
        this.audioNextQuestion.play();
        if ((this.indexQuestion) % 3 == 0)
            this.indexColor++;
        this.questionMain = this.questionList[this.indexQuestion];
    }
    calculatedValueCategory() {
        for (var i = 0; i < this.scoreCategory.length; i++) {
            let media = 9 / this.scoreCategory[i];
            let pos = 0;
            if (media >= 1 && media < 1.5)
                pos = 2;
            else if (media >= 1.5 && media < 3)
                pos = 1;
            this.resultQuestion[i] = pos;
        }
    }
    getIndexCategory(id) {
        switch (id) {
            case 9: return 0;
            case 6: return 1;
            case 7: return 2;
            case 8: return 3;
            case 10: return 4;
        }
    }
    loadAudio() {
        this.audioResult = new Audio('assets/song/nextQuestion.wav');
        this.audioNextQuestion = new Audio('assets/song/nextQuestion.wav');
        this.audioFondo = new Audio('assets/song/fondoPartida.wav');
        this.audioFondo.volume = 1;
        this.audioFondo.loop = true;
    }
};
PlayPageComponent.ctorParameters = () => [
    { type: _service_play_data_service__WEBPACK_IMPORTED_MODULE_2__["PlayDataService"] },
    { type: _service_url_default_service__WEBPACK_IMPORTED_MODULE_3__["UrlDefaultService"] }
];
PlayPageComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'play-page',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./play-page.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/page/play-page/play-page.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./play-page.component.css */ "./src/app/page/play-page/play-page.component.css")).default]
    })
], PlayPageComponent);



/***/ }),

/***/ "./src/app/service/color.service.ts":
/*!******************************************!*\
  !*** ./src/app/service/color.service.ts ***!
  \******************************************/
/*! exports provided: ColorService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorService", function() { return ColorService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ColorService = class ColorService {
    constructor() {
        this.colorLineTime = [
            "#dbd879",
            "#bec023",
            "#97991e",
            "#c1d9ea",
            "#85bde4",
            "#4891bb",
            "#c7bad9",
            "#9379aa",
            "#644684",
            "#f2cee9",
            "#b548a5",
            "#ce7cbf",
            "#f4b06c",
            "#f1a54d",
            "#c4640e"
        ];
        this.colorMain = [
            { colorMain: "#c7bad9", colorSelect: "#b548a5" },
            { colorMain: "#f2cee9", colorSelect: "#b548a5" },
            { colorMain: "#dbd879", colorSelect: "#b548a5" },
            { colorMain: "#f1a54d", colorSelect: "#b548a5" },
            { colorMain: "#85bde4", colorSelect: "#b548a5" }
        ];
    }
    /**
     * Colores de la barra de footer
     */
    getListColors() {
        return this.shuffleArray(this.colorLineTime);
    }
    /**
     * Colores del estilo de la tematicas
     */
    getListMainColors() {
        let auxColorMain = this.colorMain.slice();
        return this.shuffleArray(auxColorMain);
    }
    shuffleArray(arra) {
        for (let i = arra.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            let temp = arra[i];
            arra[i] = arra[j];
            arra[j] = temp;
        }
        return arra;
    }
};
ColorService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ColorService);



/***/ }),

/***/ "./src/app/service/http.service.ts":
/*!*****************************************!*\
  !*** ./src/app/service/http.service.ts ***!
  \*****************************************/
/*! exports provided: HttpService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpService", function() { return HttpService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");




let HttpService = class HttpService {
    constructor(http) {
        this.http = http;
    }
    init(urlServer) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.ipServer = urlServer;
        });
    }
    get(url, params) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            try {
                const headers = this.getHeader();
                let response = yield this.http.get(`${this.ipServer}/${url}`, { headers, params: params, observe: 'response' })
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["debounceTime"])(1500))
                    .toPromise();
                return response;
            }
            catch (er) {
                console.log(er);
            }
            return null;
        });
    }
    post(url, body) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            try {
                const headers = this.getHeader();
                let response = yield this.http.post(`${this.ipServer}/${url}`, body, { headers, observe: 'response' })
                    .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["debounceTime"])(1500))
                    .toPromise();
                return response;
            }
            catch (er) {
                console.log(er);
            }
            return null;
        });
    }
    getHeader() {
        return new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
            'Content-Type': 'application/json',
            // 'Authorization': this.token,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
        });
    }
};
HttpService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
HttpService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], HttpService);



/***/ }),

/***/ "./src/app/service/play-data.service.ts":
/*!**********************************************!*\
  !*** ./src/app/service/play-data.service.ts ***!
  \**********************************************/
/*! exports provided: PlayDataService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlayDataService", function() { return PlayDataService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _http_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./http.service */ "./src/app/service/http.service.ts");
/* harmony import */ var _url_default_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./url-default.service */ "./src/app/service/url-default.service.ts");




let PlayDataService = class PlayDataService {
    constructor(http, urlConst) {
        this.http = http;
        this.urlConst = urlConst;
        this.maxQuestion = 15;
    }
    /*async getQuestion() : Promise<Question[]> {
      await this.http.init( this.urlConst.getUrlApiGame() );
      let dataResponse = await this.http.get("pregunta/GetPreguntasAsignatura", {"Asignatura": 6});
      console.log(dataResponse.body)
      if(!dataResponse || !dataResponse.ok || dataResponse.status != 200) return [];
      return this.getCastQuestion(dataResponse.body);
    }*/
    getCastQuestion(data) {
        if (!data || !Array.isArray(data))
            return [];
        let questions = [];
        data.forEach(aq => {
            let q = {
                id: aq.PK_Id,
                text: aq.Contexto,
                category: aq.fkCategoria.PK_Id,
                answer: this.getCastAnswer(aq.opcions)
            };
            questions.push(q);
        });
        return questions;
    }
    getCastAnswer(data) {
        if (!data)
            return [];
        let answs = [];
        data.forEach(answ => {
            answs.push({
                id: answ.PK_Id,
                text: answ.Nombre,
                score: answ.Puntaje
            });
        });
        return answs;
    }
    getQuestion() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.http.init(this.urlConst.getUrlApiGame());
            let dataResponse = yield fetch("./assets/data.json");
            if (!dataResponse || !dataResponse.ok || dataResponse.status != 200)
                return [];
            let aux = this.getCastQuestion(yield dataResponse.json());
            return aux;
        });
    }
};
PlayDataService.ctorParameters = () => [
    { type: _http_service__WEBPACK_IMPORTED_MODULE_2__["HttpService"] },
    { type: _url_default_service__WEBPACK_IMPORTED_MODULE_3__["UrlDefaultService"] }
];
PlayDataService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], PlayDataService);



/***/ }),

/***/ "./src/app/service/url-default.service.ts":
/*!************************************************!*\
  !*** ./src/app/service/url-default.service.ts ***!
  \************************************************/
/*! exports provided: UrlDefaultService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlDefaultService", function() { return UrlDefaultService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let UrlDefaultService = class UrlDefaultService {
    constructor() {
        this.urlFileExternal = "./assets/dataServer.json";
    }
    getUrlApiGame() {
        //3.136.203.179
        return this.getDataConfig("ipApiGame", "http://3.136.203.179:3000");
    }
    getUrlImgGame() {
        return this.getDataConfig("urlImg", "imagen");
    }
    getUrlApiLogin() {
        return this.getDataConfig("ipApiLogin", "http://3.136.203.179:3000");
    }
    getDataConfig(property, valueDefault) {
        let val = localStorage.getItem(property);
        if (val)
            return val;
        return valueDefault;
    }
    ExternalFileConfig() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            let dataConfig = yield fetch(this.urlFileExternal);
            if (!dataConfig.ok)
                return null;
            let dataConfigJson = yield dataConfig.json();
            Object.getOwnPropertyNames(dataConfigJson).forEach(name => {
                localStorage.setItem(name, dataConfigJson[name]);
            });
        });
    }
};
UrlDefaultService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], UrlDefaultService);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/mavc/Documentos/UDLA/RecursoCentroMultimedia/Comtic-PCM-master/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map